import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import _IconCheck from "@arco-design/web-react/icon/react-icon/IconCheck";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconEmail from "@arco-design/web-react/icon/react-icon/IconEmail";
import React, { useRef, useState } from 'react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
import api from '@/utils/api';
export default function RegisterForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  // 删除验证链接状态
  const t = useLocale(locale);
  function handleRegister(values) {
    setErrorMessage('');
    setSuccessMessage('');
    // 删除验证链接状态重置
    setLoading(true);

    // 调用注册API
    api.post('/api/register', {
      username: values.userName,
      email: values.email,
      password: values.password,
      password_confirmation: values.password_confirmation
    }).then(response => {
      // 删除验证链接获取和设置代码

      setSuccessMessage(t['register.form.successMsg']);
      // 注册成功后重置表单
      formRef.current.resetFields();
      // 3秒后跳转到登录页
      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    }).catch(error => {
      setErrorMessage(error.message || t['register.form.register.errMsg']);
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    if (!agreeTerms) {
      setErrorMessage(t['register.form.agreeTerms.errMsg']);
      return;
    }
    formRef.current.validate().then(values => {
      handleRegister(values);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-title']
  }, t['register.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-sub-title']
  }, t['register.form.subTitle']), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-error-msg']
  }, errorMessage), successMessage && /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-success-msg']
  }, successMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['register-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      userName: '',
      email: '',
      password: '',
      password_confirmation: ''
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "email",
    rules: [{
      required: true,
      message: t['register.form.email.errMsg']
    }, {
      type: 'email',
      message: t['register.form.email.formatErrMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconEmail, null),
    placeholder: t['register.form.email.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['register.form.password.errMsg']
    }, {
      min: 6,
      message: t['register.form.password.minErrMsg']
    }
    // { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, message: t['register.form.password.formatErrMsg'] }
    ]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['register.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password_confirmation",
    rules: [{
      required: true,
      message: t['register.form.password_confirmation.errMsg']
    }, {
      validator(value, callback) {
        if (value !== formRef.current.getFieldValue('password')) {
          callback(new Error(t['register.form.password_confirmation.matchErrMsg']));
        } else {
          callback();
        }
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconCheck, null),
    placeholder: t['register.form.password_confirmation.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: agreeTerms,
    onChange: setAgreeTerms
  }, t['register.form.agreeTerms'], ' ', /*#__PURE__*/React.createElement(_Link, null, t['register.form.termsLink']))), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['register.form.register']), /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-login-link']
  }, t['register.form.haveAccount'], ' ', /*#__PURE__*/React.createElement(_Link, {
    href: "/login"
  }, t['register.form.loginLink'])))));
}